import type { CustomerPortalModule } from './portal/index.js';
import type { CustomerModule } from './customer.js';
import type { OffersModule } from './offers.js';

declare const __TGD_COMMERCE_CDN__: string;
type Commerce = { CustomerPortalModule: typeof CustomerPortalModule; OffersModule: typeof OffersModule; CustomerModule: typeof CustomerModule };
declare global { interface Window { TagadaHeadlessCommerce?: Commerce } }
const script = typeof document === 'undefined' ? null : document.currentScript as HTMLScriptElement | null;
const url = script?.src ? new URL('tagada-headless-commerce.min.js', script.src).href : __TGD_COMMERCE_CDN__;
let loading: Promise<Commerce> | undefined;

export function loadCommerce(): Promise<Commerce> {
  if (window.TagadaHeadlessCommerce) return Promise.resolve(window.TagadaHeadlessCommerce);
  if (!loading) loading = new Promise<Commerce>((resolve, reject) => {
    const element = document.createElement('script');
    element.src = url; element.async = true;
    if (script?.nonce) element.nonce = script.nonce;
    element.addEventListener('load', () => window.TagadaHeadlessCommerce ? resolve(window.TagadaHeadlessCommerce) : reject(new Error('Commerce bundle did not initialize')));
    element.addEventListener('error', () => { element.remove(); reject(new Error('Unable to load commerce bundle')); });
    document.head.appendChild(element);
  }).catch(error => { loading = undefined; throw error; });
  return loading;
}
